import React, { Component } from "react"
import $ from 'jquery'
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

class PDFModal extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            transactionNo: null,
        }
        this.renderPDFHaveHeaderFooter = this.renderPDFHaveHeaderFooter.bind(this);
        this.renderPDFNoneHeaderFooter = this.renderPDFNoneHeaderFooter.bind(this);
        this.exportPDFHaveHeaderFooter = this.exportPDFHaveHeaderFooter.bind(this);
        this.exportPDFNoneHeaderFooter = this.exportPDFNoneHeaderFooter.bind(this);
    }

    async exportPDFHaveHeaderFooter() {
        this.setState({
            pdf_data : 'abcde',
        })
        await this.renderPDFHaveHeaderFooter()
    }

    async exportPDFNoneHeaderFooter() {
        this.setState({
            pdf_data : 'abcde',
        })
        await this.renderPDFNoneHeaderFooter()
    }

    async renderPDFHaveHeaderFooter() {

        var HTML_Width = $('#page-pdf').width();
        var HTML_Height = $('#page-pdf').height();

        var top_left_margin = 25;
        var PDF_Width = HTML_Width + (top_left_margin * 1.5);
        var PDF_Height = (PDF_Width) + (top_left_margin * 2.5);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;

        var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1 ;
        if (totalPDFPages === 0) {
            totalPDFPages = 1;
        }
        console.log('HTML_Height:' + HTML_Height);
        console.log('PDF_Height:' + PDF_Height);

        await html2canvas($("#page-pdf")[0], {
            allowTaint: false,
            letterRendering: false,
            onclone: function (clonedDoc) {
                clonedDoc.getElementById('page-pdf').style.display = 'block';
            }
        }).then(function (canvas) {

                canvas.getContext('a4');
                console.log(canvas.height + "  " + canvas.width);
                var imgData = canvas.toDataURL("image/jpeg", 1);
                //console.log(imgData);
                var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
                pdf.addImage(imgData, 'PNG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);


                // for (var i = 1; i <= totalPDFPages; i++) {
                //     pdf.addPage(PDF_Width, PDF_Height);
                //     pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height * i) + (top_left_margin * 4), canvas_image_width, canvas_image_height);
                // }
                //window.open(URL.createObjectURL("bloburl"), "_blank");
                //window.location.href = pdf.output("bloburl")
                //pdf.setProperties({title:"Test"});
                
                window.open(pdf.output("bloburl"), "_blank");
                
                // pdf.output("dataurlnewwindow")
                // pdf.save("แบบฟอร์มใบตรวจรับคู้ค้า_202109132110.pdf");
                // window.open(URL.createObjectURL(blob));
            });

    }

    async renderPDFNoneHeaderFooter() {

        var HTML_Width = $('#page-pdf').width();
        var HTML_Height = $('#page-pdf').height();

        var top_left_margin = 25;
        var PDF_Width = HTML_Width + (top_left_margin * 1.5);
        var PDF_Height = (PDF_Width) + (top_left_margin * 2.5);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;

        var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1 ;
        if (totalPDFPages === 0) {
            totalPDFPages = 1;
        }
        console.log('HTML_Height:' + HTML_Height);
        console.log('PDF_Height:' + PDF_Height);

        html2canvas($("#report_body")[0], {
            allowTaint: false,
            letterRendering: false,
            onclone: function (clonedDoc) {
                clonedDoc.getElementById('page-pdf').style.display = 'block';
            }
        }).then(function (canvas) {

                canvas.getContext('a4');
                console.log(canvas.height + "  " + canvas.width);
                var imgData = canvas.toDataURL("image/jpeg", 1);
                //console.log(imgData);
                var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
                pdf.addImage(imgData, 'PNG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);


                // for (var i = 1; i <= totalPDFPages; i++) {
                //     pdf.addPage(PDF_Width, PDF_Height);
                //     pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height * i) + (top_left_margin * 4), canvas_image_width, canvas_image_height);
                // }
                //window.location.href = pdf.output("bloburl")
                window.open(pdf.output("bloburl"), "_blank");
                // pdf.output("dataurlnewwindow")
                // pdf.save("html2pdf.pdf");
                // window.open(URL.createObjectURL(blob));
            });

    }

    render() {
        return (
           
            <div className="modal fade sp-modal rrs-modal"  id="pdfModal" tabIndex={-1} role="dialog" aria-labelledby="searchPoModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document" style={{maxWidth:1040}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchEmployeeModalLabel">กรุณาเลือกแบบฟอร์มใบตรวจรับ</h5>
                            <input type="hidden" id="MR_DETAIL_Field_key"/>
                            <input type="hidden" id="MR_DETAIL_Field_val"/>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" >
                                <span aria-hidden="true">×</span>
                            </button>
                          
                        </div>
                  
                   
                        <div className="modal-body">

                        <div className="rrs-detail2">
                            <div className="rrs-form-group-search">
                                <button className="btn btn-info" onClick={this.exportPDFHaveHeaderFooter} ><h5 className="modal-title">เเบบมี Header/Footer</h5></button> 
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <button className="btn btn-info" onClick={this.exportPDFNoneHeaderFooter} ><h5 className="modal-title">เเบบไม่มี Header/Footer</h5></button> 
                            </div>
                        </div>
                        </div>
                </div>
            </div>        

                

            </div>

            
        )
    }
}
export default PDFModal